module.exports = __webpack_public_path__ + "static/media/3pic.668991bd.png";